import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

interface HomeMessagesAuthData {
  country?: string
  isExternal?: boolean
  commonData?: { salesScriptEnabled?: boolean }
}

// Same flag as the sales scripts: the Dev Tools tab that edits these sections opens with it.
export const isHomeMessagesAvailable = ({
  country = '',
  isExternal = false,
  commonData,
}: HomeMessagesAuthData): boolean =>
  // @ts-ignore
  Boolean(modulesConfig[country]?.home?.messages) && commonData?.salesScriptEnabled === true && !isExternal
